// Shared surface for chrome that floats directly on the Global Produce Map.
//
// Every control that sits on map tiles rather than a page background — the
// layer rail, the Combine popover, the filter pills, the arrivals strip, the
// fullscreen button — uses the same translucent, blurred card: a hairline
// #111827/9 border and a soft 2px/10px shadow so it stays legible over any
// tile colour. Only the fill opacity differs, which is why it is a parameter
// rather than a single string.
//
// The fills are spelled out as literals because Tailwind only emits classes it
// can read in the source; `bg-white/${n}` would produce nothing.

const BASE = "border-[#111827]/9 shadow-[0px_2px_10px_0px_#1118271A] backdrop-blur-[8px] dark:border-white/8 dark:shadow-[0px_2px_10px_0px_#00000066]";

const FILLS = {
  94: 'bg-white/94 dark:bg-[#1B1F1C]/94',
  95: 'bg-white/95 dark:bg-[#1B1F1C]/95',
  97: 'bg-white/97 dark:bg-[#1B1F1C]/97',
};

/**
 * @param {94|95|97} fill Fill opacity. The denser values are for surfaces
 *   carrying small text (the arrivals strip at 97) where tiles showing through
 *   would hurt legibility; 94 is the default for icon-led chrome.
 * @returns {string} Tailwind classes. The caller still owns size, radius and
 *   the `border` shorthand itself.
 */
export const floatingSurfaceClass = (fill = 94) => `${FILLS[fill] || FILLS[94]} ${BASE}`;

export default floatingSurfaceClass;
